<div *ngIf="group" [formGroup]="group" class="custom-control custom-switch">
    <input (ngModelChange)="change($event)" [attr.disabled]="disabled ? disabled : null"
           [checked]="modelAttribute"
           [formControlName]="fcName"
           [id]="fcName + i"
           [name]="fcName + i"
           class="custom-control-input green"
           type="checkbox">
    <label [for]="fcName+i" class="custom-control-label">{{label}}</label>
</div>
<div *ngIf="!group" class="custom-control custom-switch">
    <input (change)="changeEvent($event)" [attr.disabled]="disabled ? disabled : null"
           [id]="fcName + i"
           [name]="fcName + i"
           class="custom-control-input green"
           type="checkbox">
    <label [for]="fcName+i" class="custom-control-label">{{label}}</label>
</div>
